<template>
  <div class="twp-mapper">
    <TText
      :text="`${is_create?'Create ':''}WORK.package mapper`"
      color="black"
      font_weight="500"
    />
    <TFlex direction="row">
      <TFlex style="width:50%;" wrap="wrap" direction="column">
        <v-btn x-small @click="show_options=!show_options"><TText size="8" text="select"/></v-btn>
        <v-btn x-small color="green" @click="$emit(`changeMapper`, mapper_workpackage);reset();"><TText size="8" text="save"/></v-btn>
        <v-btn v-if="!is_create" x-small color="red" @click="$emit(`deleteMapper`, mapper_workpackage);"><TText size="8" text="delete"/></v-btn>
        <div v-if="show_options" class="wp-options">
          <TFlex wrap="wrap" direction="column">
            <TWorkPackage
            v-for="(workpackage, index) in getUniqueTWorkPackagesByProject($route.params.project_id)"
            :key="`wpiteration${index}`"
            :workpackage_count="1"
            :workpackage="workpackage"
            :easter_egg="false"
            :color="workpackage.color"
            @click.native="mapperChange(workpackage)"
            class="cursor-pointer"
            />
          </TFlex>
        </div>
      </TFlex>
      <TFlex style="width:50%;">
        <TWorkPackage
          :workpackage_count="1"
          :workpackage="mapper_workpackage"
          :easter_egg="false"
          :zoom="2.5"
          :color="mapper_workpackage.color"
        />
      </TFlex>
    </TFlex>
  </div>
</template>
<script>
import {
  mapGetters,
  // mapActions
} from 'vuex';
import { TColor } from '@/mixins/TColor.mixin.js'
import TText from '@/components/Taktify/TText.component.vue';
import TFlex from '@/components/Taktify/TFlex.component.vue';
import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
export default {
  components: {
    TText,
    TFlex,
    TWorkPackage,
  },
  mixins: [TColor],
  props: ['twpmapper'],
  data: () => ({
    show_options: false,
    is_create: false,
    mapper_workpackage: {
      color: '',
      token: '',
      icon: ''
    }
  }),
  created(){
    if (this.twpmapper) {
      this.mapper_workpackage = this.twpmapper;
    } else {
      this.is_create = true;
      this.mapper_workpackage = this.getUniqueTWorkPackagesByProject(this.$route.params.project_id)[0];
    }
  },
  computed: {
    ...mapGetters('TWorkPackage', [
      'getUniqueTWorkPackagesByProject',
    ])
  },
  methods: {
    reset(){
      this.show_options = false;
    },
    mapperChange(workpackage){
      this.mapper_workpackage = workpackage;
    }
  }
}
</script>
<style scoped>
.wp-options {
  max-height: 400px;
  width: 160px;
  padding: 5px;
  overflow-y: scroll;
  position: absolute;
  z-index: 10;
  background-color: grey;
  margin-top: 25px;
}
.twp-mapper {
  /* background-color: var(--v-color-3-base); */
  background-color: rgb(158, 158, 158);
  width: 344px;
  border-radius: 4px;
  padding: 5px;
}
</style>
